export const IMAGES = {
  ICON_RELOAD: `${process.env.PUBLIC_URL}/img/icon_reload.png`,
  SAVVY_ICON: `${process.env.PUBLIC_URL}/img/s-logo.png`,
  MOTILAL_OSWAL: "https://groww.in/images/partners/motilal_groww.svg",
};
